<template>
  <header class="header">
    <nav>
      <a href=""><img src="../assets/img/logo.svg" alt="Logo JBS 70 anos" /></a>
      <button @click.prevent="handdleMenu">Ver Lista</button>
    </nav>
    <section :class="['header__menu', menu ? 'active' : '']">
      <div class="header__menu__content">
        <header>
          <a href=""
            ><img
              src="../assets/img/logo-white.svg"
              alt="Logo branco JBS 70 anos"
          /></a>
          <button @click.prevent="handdleMenu">Fechar</button>
        </header>
        <ul>
          <li>
            <a href="#1953" @click="handdleMenu">
              <span>1953</span>
              <p>A Casa de Carnes Mineira</p>
            </a>
          </li>
          <li>
            <a href="#1957" @click="handdleMenu">
              <span>1957</span>
              <p>No coração do Brasil</p>
            </a>
          </li>
          <li>
            <a href="#1970" @click="handdleMenu">
              <span>1970</span>
              <p>Nasce a Friboi</p>
            </a>
          </li>
          <li>
            <a href="#1980" @click="handdleMenu">
              <span>1980</span>
              <p>Expansão nacional</p>
            </a>
          </li>
          <li>
            <a href="#1988" @click="handdleMenu">
              <span>1988</span>
              <p>De volta às origens</p>
            </a>
          </li>
          <li>
            <a href="#1993" @click="handdleMenu">
              <span>1993</span>
              <p>Ultrapassando fronteiras</p>
            </a>
          </li>
          <li>
            <a href="#1996" @click="handdleMenu">
              <span>1996</span>
              <p>Padrão europeu</p>
            </a>
          </li>
          <li>
            <a href="#1997" @click="handdleMenu">
              <span>1997</span>
              <p>Modelo JBS</p>
            </a>
          </li>
          <li>
            <a href="#1999" @click="handdleMenu">
              <span>1999</span>
              <p>Industrialização da produção</p>
            </a>
          </li>
          <li>
            <a href="#2004" @click="handdleMenu">
              <span>2004</span>
              <p>Centralização em São Paulo</p>
            </a>
          </li>
          <li>
            <a href="#2005" @click="handdleMenu">
              <span>2005</span>
              <p>Rompendo fronteiras</p>
            </a>
          </li>
          <li>
            <a href="#2007" @click="handdleMenu">
              <span>2007</span>
              <p>Capital aberto, EUA e Austrália</p>
            </a>
          </li>
          <li>
            <a href="#2008" @click="handdleMenu">
              <span>2008</span>
              <p>Liderança na indústria da carne</p>
            </a>
          </li>
          <li>
            <a href="#2009" @click="handdleMenu">
              <span>2009</span>
              <p>Ampliação nos EUA e no Brasil</p>
            </a>
          </li>
          <li>
            <a href="#2010" @click="handdleMenu">
              <span>2010</span>
              <p>A expansão continua</p>
            </a>
          </li>
          <li>
            <a href="#2011" @click="handdleMenu">
              <span>2011</span>
              <p>Crescimento no mercado europeu</p>
            </a>
          </li>
          <li>
            <a href="#2012" @click="handdleMenu">
              <span>2012</span>
              <p>Crescimento contínuo</p>
            </a>
          </li>
          <li>
            <a href="#2013" @click="handdleMenu">
              <span>2013</span>
              <p>Fortalecimento, liderança e expansão</p>
            </a>
          </li>
          <li>
            <a href="#2014" @click="handdleMenu">
              <span>2014</span>
              <p>Expansão das operações de Aves no Brasil e México</p>
            </a>
          </li>
          <li>
            <a href="#2015" @click="handdleMenu">
              <span>2015</span>
              <p>Uma empresa global</p>
            </a>
          </li>
          <li>
            <a href="#2019" @click="handdleMenu">
              <span>2019</span>
              <p>Avanços na Europa e no Brasil</p>
            </a>
          </li>
          <li>
            <a href="#2020" @click="handdleMenu">
              <span>2020</span>
              <p>Sustentabilidade e solidariedade</p>
            </a>
          </li>
          <li>
            <a href="#2021" @click="handdleMenu">
              <span>2021</span>
              <p>Descarbonização e mercado global</p>
            </a>
          </li>
          <li>
            <a href="#2022" @click="handdleMenu">
              <span>2022</span>
              <p>Inovação e segmentação</p>
            </a>
          </li>
          <li>
            <a href="#2023" @click="handdleMenu">
              <span>2023</span>
              <p>
                A JBS apresenta ao mundo uma marca que reflete a jornada de
                crescimento e evolução da companhia.
              </p>
            </a>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    handdleMenu() {
      this.menu = !this.menu;
      if (this.menu) {
        document.querySelector('body')?.classList.add('no-scroll');
      } else {
        document.querySelector('body')?.classList.remove('no-scroll');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  position: fixed;
  top: 0%;
  left: 0;
  width: 100%;
  z-index: 100;
  nav {
    display: flex;
    justify-content: space-between;
    align-content: center;
    padding: 30px 45px;
    @include media('<=desktop') {
      padding: 30px 20px;
    }
    button {
      background: none;
      border: none;
      color: color(cBlue);
      font-family: font(primary);
      font-size: 0.625rem;
      font-style: normal;
      font-weight: 700;
      line-height: 135%; /* 0.84375rem */
      text-transform: uppercase;
      transition: 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        color: color(cBlue2);
      }

      &::before {
        content: '\e904';
        font-family: 'icomoon' !important;
        display: block;
        text-align: left;
        margin-block: 0.5rem;
        font-size: 0.8rem;
      }
    }
  }
  &__menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: color(primary);
    z-index: 9999;
    transform: translateY(-100%);
    transition: 0.5s ease-in-out;
    &.active {
      transform: translate(0);
    }
    &__content {
      overflow-y: scroll;
      height: 100%;
      padding-bottom: 40px;
    }
    header {
      display: flex;
      justify-content: center;
      text-align: center;
      padding: 45px 55px;
      position: relative;
      a {
        display: inline-block;
      }

      button {
        background: none;
        border: none;
        color: color(cWhite);
        font-family: font(primary);
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 700;
        line-height: 135%; /* 0.84375rem */
        text-transform: uppercase;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        position: absolute;
        right: 55px;
        top: 45px;

        &:hover {
          color: color(cBlue);
        }

        &::before {
          content: '\e902';
          font-family: 'icomoon' !important;
          display: block;
          text-align: left;
          margin-block: 0.5rem;
          font-size: 0.8rem;
        }
      }
    }
    ul {
      margin: 0 auto;
      list-style: none;
      li {
        a {
          display: block;
          text-decoration: none;
          &:hover {
            background: color(cBlue2);
          }
          p {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 243%;
            margin-top: 0.3rem;
            text-align: center;
            padding: 0 20px;
          }
          span {
            display: block;
            color: color(cWhite);
            text-align: center;
            font-family: font(primary);
            font-size: 1rem;
            font-style: normal;
            font-weight: 700;
            line-height: 243%;
            position: relative;
            padding-bottom: 0.3rem;

            &::after {
              content: '';
              width: 100px;
              height: 1px;
              background: color(cBlue3);
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }
    }
  }
}
</style>
